// src/components/Layout.js
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";
import ImpersonationBanner from "./ImpersonationBanner";

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("rb-sidebar-collapsed") === "1");

  function toggleCollapse() {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem("rb-sidebar-collapsed", next ? "1" : "0");
      return next;
    });
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <div className="rb-ambient" aria-hidden="true"><span></span><span></span><span></span></div>
      <Sidebar
        open={mobileOpen} onClose={() => setMobileOpen(false)}
        collapsed={collapsed} onToggleCollapse={toggleCollapse}
      />
      {mobileOpen && (
        <div className="rb-sidebar-backdrop" onClick={() => setMobileOpen(false)} />
      )}
      <main className="rb-main" style={{
        flex: 1,
        marginLeft: collapsed ? "var(--sidebar-w-collapsed)" : "var(--sidebar-w)",
        minHeight: "100vh",
        overflowY: "auto",
        transition: "margin-left .2s ease",
      }}>
        <div className="rb-mobile-topbar">
          <button
            onClick={() => setMobileOpen(true)}
            style={{ background: "none", border: "none", color: "#f0f4ff", cursor: "pointer", display: "flex", padding: 4 }}
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
          <img src="/logo.png" alt="Tech Bugz" style={{ height: 28, width: "auto" }} />
        </div>
        <ImpersonationBanner />
        <Outlet />
      </main>
    </div>
  );
}
